import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TvshopConstants} from '../../../shared/tvshop-constants';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {PageNames} from '../../../shared/page-names.enum';
import {Environment} from '../../../shared/environment/environment';
import {SelectableNavigationItem} from '../../../model/selectable-navigation-item';
import {ImageUtils} from '../../../shared/utils/image/image-utils';
import {OmapiIdsUtils} from '../../../shared/utils/omapi-ids/omapi-ids-utils';

@Component({
  selector: 'app-play-sports-grid-item',
  templateUrl: './play-sports-detail-grid-item.component.html',
  styleUrls: ['./play-sports-detail-grid-item.component.less']
})
export class PlaySportsDetailGridItemComponent extends SelectableNavigationItem implements OnInit {
  @Input()
  omapiId;
  @ViewChild('gridElement', {read: ElementRef})
  gridElement: ElementRef;
  @Output()
  emitBannerInfo = new EventEmitter<Object>();

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, PageNames.DETAIL_PAGE_OFFER);
  }

  onEnter(): void {
  }

  public getLogoUrl(): string {
    if (this.name) {
      return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-' + this.name + '-icon.svg';
    }
    return '';
  }

  public getBannerUrl(): string {
    if (this.name) {
      return ImageUtils.getBannerImageUrl(this.omapiId, this.name);
    }
    return '';
  }

  onEmitBannerInfo() {
    this.emitBannerInfo.emit({
      url: this.getBannerUrl()
    });
  }

  activate(active: boolean): void {
    this.active = active;
    if (this.active) {
      this.onEmitBannerInfo();
    }
  }

  canNavigateToDirection(keyCode: number): boolean {
    return true;
  }

  private baseUrl(): string {
    return Environment.environmentConfig().baseUrl;
  }

  onBack(): void {
    this.navigationService.resetPage();
  }
}


